export enum StatSources {
  Cellular = 0,
  Offline = 1,
  Satellite = 2,
}
